/**
 * PATH: apps/quote/src/pages/claims/claim-editor-page/evidence/manifest.ts
 * FILE_ID: QUOTE-CLAIMS-EVIDENCE-MANIFEST-001
 * PURPOSE: Derive deterministic reorder and send manifests from evidence rows.
 */

import type { ClaimEvidence } from './types'

export function moveEvidenceId(
  items: readonly ClaimEvidence[],
  index: number,
  direction: -1 | 1,
): string[] {
  const ids = items.map((item) => item.id)
  const target = index + direction
  if (index < 0 || index >= ids.length || target < 0 || target >= ids.length) {
    return ids
  }
  ;[ids[index], ids[target]] = [ids[target], ids[index]]
  return ids
}

export function evidenceIdsForSend(
  items: readonly ClaimEvidence[],
): string[] {
  return items
    .filter((item) => item.include_on_send && !item.is_missing)
    .map((item) => item.id)
}
